import { render, staticRenderFns } from "./FormaIngresso.vue?vue&type=template&id=baabe28c&scoped=true"
import script from "./FormaIngresso.vue?vue&type=script&lang=js"
export * from "./FormaIngresso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baabe28c",
  null
  
)

export default component.exports